import { Snackbar } from "@mui/material";
import { Button } from "antd";
import { useEffect, useState } from "react";

const ServiceWorkerWrapper = () => {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };
  // eslint-disable-next-line no-undef

  useEffect(() => {
    const swUrl = `${import.meta.env.BASE_URL}/serviceWorker.js`;
    // const swUrl = "../serviceWorker.js";

    const registerValidSW = (swUrl) => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            console.log(installingWorker.state);
            if (installingWorker == null) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  onSWUpdate(registration);
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error("Error during service worker registration:", error);
        });
    };

    const checkValidServiceWorker = (swUrl) => {
      fetch(swUrl, {
        headers: { "Service-Worker": "script" },
      })
        .then((response) => {
          console.log(response);
          const contentType = response.headers.get("content-type");
          if (
            response.status === 404 ||
            (contentType != null && contentType.indexOf("javascript") === -1)
          ) {
            navigator.serviceWorker.ready.then((registration) => {
              registration.unregister().then(() => {
                window.location.reload();
              });
            });
          } else {
            registerValidSW(swUrl);
          }
        })
        .catch(() => {
          console.log(
            "No internet connection found. App is running in offline mode."
          );
        });
    };

    const isLocalhost = Boolean(
      window.location.hostname === "localhost" ||
        window.location.hostname === "[::1]" ||
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
    } else {
      registerValidSW(swUrl);
    }
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });

    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <Snackbar
      open={showReload}
      onClose={() => showReload(false)}
      message="A new version is available, check it "
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <Button type="primary" size="small" onClick={reloadPage}>
          Reload
        </Button>
      }
    />
  );
};

export default ServiceWorkerWrapper;
